module.exports = __webpack_public_path__ + "img/illu-intestine-tooltips.6fb64d89.svg";